import { resetFilters as resetFiltersDiagram, resetTimeFilterDefaults } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    mode?: any
    processMiner? : boolean
    regenerateArray?: boolean
}

const sleep = ms => new Promise(r => setTimeout(r, ms));

export async function resetFilters ({
    mode,
    processMiner,
    regenerateArray,
    eventEmitter,
}: Props) {
    await sleep(50) // needed to display Progress
    await resetFiltersDiagram(regenerateArray); // resets the filter active variables
    const values = resetTimeFilterDefaults();
    eventEmitter.emit(Event.resetFilter);
    eventEmitter.emit(Event.resetDiscovery);
    eventEmitter.emit(Event.resetTimeFilter, values);
    if (mode === 'process_miner') apiProvider.setDiagramVisualizer()    
    if (mode === 'time_in_activity') {
        eventEmitter.emit(Event.updateTimeInActivity);
    }
    if (mode === 'decomposition_tree') {
        apiProvider.setAction_DecompositionTree({})
        apiProvider.setDiagramDecompositionTree({source: 'applyTasksFilter'})
    }
    if (mode === 'cluster_insights') {
        apiProvider.setAction_Cluster({})
        apiProvider.setDiagramCluster({source: 'applyTasksFilter'})
    }
    if (mode === 'influence_analysis') {
        apiProvider.setAction_InfluenceAnalysis({})
        apiProvider.setDiagramInfluenceAnalysis({source: 'applyTasksFilter'})
    }
    if (apiProvider.getActiveAction() ==='process_miner') apiProvider.rebuildPVDiagram('resetFilters');
    apiProvider.updateGauges({});
    //if (processMiner === true) eventEmitter.emit(Event.setActionBar_Visualizer)
};
